import React from "react";
import { Alert, Box, Heading } from "@catchoftheday/cg-components";
import { DEFAULT_DELIVERY_ESTIMATE_ERROR_MESSAGE } from "../../consts/index.js";
export const DeliveryEstimateError = ({ message, }) => (<Box borderRadius={4} overflow="hidden">
    <Alert type="inline" variant="warning" alignIcon="flex-start">
      <Heading.h5 m={0}>
        {message || DEFAULT_DELIVERY_ESTIMATE_ERROR_MESSAGE}
      </Heading.h5>
    </Alert>
  </Box>);
